const DocusignCollectionMethod = {
  DOCUSIGN: 'Docusign',
  MANUAL_COLLECTION: 'Manual Collection',
};

export default DocusignCollectionMethod;
